import React from "react"
import { Select } from "antd"
// Egasi (2026-09-02): «til almashtirishda bayroqlar chiqmayapti» — emoji Windows'da chizilmaydi,
// shuning uchun bayroqlar INLINE SVG (hamma OS/brauzerda bir xil).
function Flag({ code, size = 18 }: { code: string; size?: number }) {
  const h = Math.round(size * 0.7)
  const common = { width: size, height: h, viewBox: "0 0 30 21", style: { borderRadius: 3, boxShadow: "0 0 0 1px rgba(0,0,0,.12)", flexShrink: 0 } as React.CSSProperties }
  if (code === "RU") return (<svg {...common}><rect width="30" height="7" fill="#fff" /><rect y="7" width="30" height="7" fill="#0039a6" /><rect y="14" width="30" height="7" fill="#d52b1e" /></svg>)
  if (code === "UZ") return (<svg {...common}><rect width="30" height="7" fill="#1eb53a" /><rect width="30" height="7" y="0" fill="#0099b5" /><rect y="7" width="30" height="7" fill="#fff" /><rect y="14" width="30" height="7" fill="#1eb53a" /><rect y="6.6" width="30" height="0.8" fill="#ce1126" /><rect y="13.6" width="30" height="0.8" fill="#ce1126" /><circle cx="5.5" cy="3.5" r="2.2" fill="#fff" /><circle cx="6.3" cy="3.5" r="2.2" fill="#0099b5" /></svg>)
  return (<svg {...common}><rect width="30" height="21" fill="#012169" /><path d="M0 0L30 21M30 0L0 21" stroke="#fff" strokeWidth="4" /><path d="M0 0L30 21M30 0L0 21" stroke="#C8102E" strokeWidth="1.6" /><path d="M15 0V21M0 10.5H30" stroke="#fff" strokeWidth="6" /><path d="M15 0V21M0 10.5H30" stroke="#C8102E" strokeWidth="3.4" /></svg>)
}

// Egasi (2026-08-31): tillar BILDIRISHNOMALAR YONIDA turadi — RU / UZ / EN.
// Almashtirilganda sahifa reload bo'ladi (jadval ustunlari i18n.t bilan modul
// yuklanishida hisoblanadi — reload'siz eski tilda qolardi).
//
// Farhod #593/#620 (2026-09-01): avval bayroq EMOJI ishlatilardi («🇷🇺 RU»),
// lekin Windows/Chrome bayroq emojisini KO'RSATMAYDI — o'rniga «RU» harflarini
// chizadi va natijada tugmada «RU RU» bo'lib chiqardi (siqilgan, chalkash).
// Endi: yopiq holatda globus belgisi + qisqa kod (RU), ochilganda esa til
// TO'LIQ NOMI bilan tartibli ro'yxat — ixcham va zamonaviy.
const LANGS = [
  { value: "ru", code: "RU", name: "Русский" },
  { value: "uz", code: "UZ", name: "O‘zbekcha" },
  { value: "en", code: "EN", name: "English" },
]

export default function LangSwitcher() {
  let current = "ru"
  try {
    const v = localStorage.getItem("app_lang")
    if (v === "uz" || v === "ru" || v === "en") current = v
  } catch {}

  return (
    <Select
      size="large"
      className="headermargin_r lang-switcher"
      style={{ width: 92 }}
      value={current}
      optionLabelProp="label"
      dropdownMatchSelectWidth={false}
      dropdownStyle={{ minWidth: 190, borderRadius: 10, padding: 4 }}
      onChange={(lng) => {
        try {
          localStorage.setItem("app_lang", lng)
        } catch {}
        window.location.reload()
      }}
    >
      {LANGS.map((l) => (
        <Select.Option
          key={l.value}
          value={l.value}
          label={
            <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontWeight: 700 }}>
              <Flag code={l.code} />
              {l.code}
            </span>
          }
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 14,
              padding: "2px 0",
            }}
          >
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8, fontWeight: 600 }}><Flag code={l.code} size={20} />{l.name}</span>
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#64748b",
                background: "rgba(100,116,139,.12)",
                borderRadius: 6,
                padding: "1px 7px",
              }}
            >
              {l.code}
            </span>
          </div>
        </Select.Option>
      ))}
    </Select>
  )
}
